<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {SearchFilter} from "@/modules/redactor/models/search/SearchFilter";

export default {
  name: "r-search-filter",
  props: {
    model: VueTypes.instanceOf(SearchFilter),
    label: VueTypes.string.def("Filter:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SearchFilter.getValues();
    }
  }
}
</script>